export default __webpack_public_path__ + "static/media/Scenic-Beauty-of-Amarkantak.8f2614d2.jpg";